<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/exercises"></ion-back-button>
    </ion-buttons>
    <ion-title>Exercise</ion-title>
    <ion-buttons slot="primary">
      <ion-button [routerLink]="['/training-tools']" class="clicker"><ion-icon
          src="../../assets/images/icons/clicker.svg" slot="icon-only"
          size="large"></ion-icon></ion-button></ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <div class="ion-text-center ion-padding" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <ion-grid *ngIf="!isLoading">
    <ion-row>
      <ion-col class="ion-text-center title" sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        {{exercise.name}}
      </ion-col>
    </ion-row>

    <ion-row><ion-col class="goal" sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        {{exercise.goal}}</ion-col>
    </ion-row>

    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <div class="video-container">
          <iframe width="100%" height="315" [src]="trustedLink" title="YouTube video player" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
      </ion-col>
    </ion-row>
    <ion-row><ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <div class="icons">
          <a style="color: #128c7e" [href]="'whatsapp://send?text=Your fur baby will love this exercise!! ' + url"
            data-action="share/whatsapp/share"><ion-icon name="logo-whatsapp"></ion-icon></a>

          <ion-icon class="icon" name="copy-outline" (click)="copyLink()"></ion-icon>

          <ion-icon name="share-social-outline" class="pointer" (click)="shareArticle()"></ion-icon>
        </div>
      </ion-col></ion-row>
    <ion-row>
      <ion-col class="desc" sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <div class="ion-text-center follow">Follow These Steps</div>
        <div [innerHTML]="newDirections"></div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>